import { jsx as c, jsxs as d } from "react/jsx-runtime";
import { forwardRef as f, useContext as m } from "react";
import { Button as x } from "../button/Button.js";
import { ChartCoreContext as g } from "./ChartCoreContext.js";
import { getColorClassName as h } from "./chartUtils.js";
import { twMerge as n } from "tailwind-merge";
const y = (p) => {
  const { value: r, color: s, onClick: t, variant: l = "none", ...i } = p, { activeLegend: o, selectCategory: e, enableLegendToggle: a } = m(g);
  return /* @__PURE__ */ d(
    x,
    {
      variant: l,
      className: n(
        "group flex-nowrap items-center gap-1.5 whitespace-nowrap rounded px-2 py-1 transition",
        a ? "cursor-pointer hover:bg-gray-100" : "cursor-default"
      ),
      onClick: (u) => {
        a && e(r), t == null || t(u);
      },
      ...i,
      children: [
        /* @__PURE__ */ c(
          "span",
          {
            className: n(
              "h-[3px] w-3.5 shrink-0 rounded-full",
              h(s, "bg"),
              o && o !== r ? "opacity-40" : "opacity-100"
            ),
            "aria-hidden": !0
          }
        ),
        /* @__PURE__ */ c(
          "p",
          {
            className: n(
              "truncate whitespace-nowrap text-xs text-gray-700",
              a && "group-hover:text-gray-900",
              o && o !== r ? "opacity-40" : "opacity-100"
            ),
            children: r
          }
        )
      ]
    }
  );
}, j = f((p, r) => {
  const { payload: s, className: t } = p, { categoryColors: l } = m(g), i = s.map((e) => e.value), o = s.map((e) => l.get(e.value));
  return /* @__PURE__ */ c("div", { ref: r, className: n("flex flex-wrap", t), children: i.map((e, a) => /* @__PURE__ */ c(
    y,
    {
      value: e,
      color: o[a]
    },
    e
  )) });
});
export {
  j as ChartLegend,
  y as LegendItem
};
